/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OrganizationRawMaterialPreferences = {
  /**
   * The method used for composition calculations, for this raw material
   */
  composition_calculation_method?: OrganizationRawMaterialPreferences.composition_calculation_method;
};
export namespace OrganizationRawMaterialPreferences {
  /**
   * The method used for composition calculations, for this raw material
   */
  export enum composition_calculation_method {
    AVERAGE_OF_RANGE = "average_of_range",
    MAXIMUM_OF_RANGE = "maximum_of_range",
    NORMALIZE_SUM_OF_AVERAGES = "normalize_sum_of_averages",
    NORMALIZE_SUM_OF_MAXIMUMS = "normalize_sum_of_maximums",
  }
}
